import { Button } from '@kc-console/common-ui';
import { useScopedNavigation } from '@kc-console/context';
import { getConsoleBaseUrl, useTranslation } from '@kc-console/core';
import { IcHeadphoneRegular } from '@kep/kcds-icons';

import type { ButtonProps } from '@kc-console/common-ui';

interface HelpdeskButtonProps extends ButtonProps {
  fullReloadOnRoute?: boolean;
  isInService?: boolean;
}

export default function HelpdeskButton({
  fullReloadOnRoute = false,
  isInService = false,
  ...props
}: HelpdeskButtonProps) {
  const { t } = useTranslation();
  const { goToScopedPath } = useScopedNavigation();
  const handleGoToHelpdesk = () => {
    if (fullReloadOnRoute) {
      window.location.href = `${getConsoleBaseUrl()}/helpdesk/qna`;
    } else {
      goToScopedPath('/helpdesk/qna');
    }
  };

  if (isInService) {
    return (
      <Button variant="primary" size="lg" onClick={handleGoToHelpdesk} {...props}>
        {t('ui:error_page.help_desk')}
      </Button>
    );
  }

  return (
    <Button
      variant="tertiary"
      size="xl"
      startIcon={<IcHeadphoneRegular />}
      onClick={handleGoToHelpdesk}
      {...props}
    >
      {t('ui:error_page.help_desk')}
    </Button>
  );
}
